export default __webpack_public_path__ + "static/media/carImage.514de29b.png";